<template>
  <details class="contentDisclosure">
    <summary class="contentDisclosure__summary">
      <slot name="title" />
      <span
        class="contentDisclosure__icon"
        aria-hidden="true"></span>
    </summary>
    <div class="contentDisclosure__content">
      <slot name="content" />
    </div>
  </details>
</template>

<style lang="scss" scoped>
  .contentDisclosure {
    margin: 24px 0;
    border: 2px solid currentColor;

    &[open] {
      .contentDisclosure__icon {
        transform: rotate(225deg) translateY(2px);
      }
    }
  }

  .contentDisclosure__summary {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 16px 18px;
    list-style: none;
    cursor: pointer;

    &::-webkit-details-marker {
      display: none;
    }

    :deep(*) {
      margin: 0;
    }
  }

  .contentDisclosure__icon {
    flex: 0 0 auto;
    width: 10px;
    height: 10px;
    border-right: 2px solid currentColor;
    border-bottom: 2px solid currentColor;
    transform: rotate(45deg) translateY(-2px);
    transform-origin: center;
    transition: transform 0.2s ease;
  }

  .contentDisclosure__content {
    padding: 0 18px 18px;
  }
</style>
